<script setup lang="ts">
import SearchField from '@/components/filter/SearchField.vue';
import { I18nKey } from '@/utils/typings';
import { ImportedMeasurementOverviewFilterObject } from '../types';

const modelValue = defineModel<ImportedMeasurementOverviewFilterObject>({ required: true });

const searchedFieldsI18nKeys = [
  'MeasurementDate',
  'TrackItAlias',
  'TrackItMeasuringDevice',
  'TrackItMeasuringSoftware',
  'ImportDate',
  'ImportUser',
] as I18nKey[];
</script>

<template>
  <v-row class="align-center mt-2 pl-2 pr-2">
    <v-col cols="12" md="6" lg="3" class="pa-2">
      <SearchField
        v-model:modelValue="modelValue.search"
        :placeholder="
          $t('Search', {
            columns: searchedFieldsI18nKeys.map((key) => `$t(${key})`),
          })
        "
      />
    </v-col>
  </v-row>
</template>
